import {
  LANGUAGE_NICE_NAMES,
  type MightierSupportedLanguage,
} from "@neuromotion-inc/mightier-ts-sdk";

export const languageOptions: {
  value: MightierSupportedLanguage;
  label: string;
}[] = Object.entries(LANGUAGE_NICE_NAMES).map((pair) => {
  return { value: pair[0] as MightierSupportedLanguage, label: pair[1] };
});
